import { queryOptions } from '@tanstack/react-query';
import { listSystemSimulations } from '~/pages/SystemSimulationsPage/api/systemSimulations.api';
import { IdfChartOptionsModel } from '~/pages/SystemSimulationsPage/models/IdfChartOptionsModel';
import { SystemSimulationsListModel } from '~/pages/SystemSimulationsPage/models/SystemSimulationsListModel';
import { ChartMetricModel } from '~/shared/models/metrics/ChartMetricModel';
import { listSimulationMetrics } from '~/services/api/fetchers/metrics.api';
import { SimulationModel } from '~/shared/models/system/SimulationModel';

export const listSystemSimulationsQuery = ({
  systemName,
}: {
  systemName: string;
}) =>
  queryOptions({
    queryKey: ['listSystemSimulations', { systemName }],
    queryFn: async () => {
      const response = await listSystemSimulations({ systemName });

      return new SystemSimulationsListModel(response);
    },
  });

export const IDF_RESERVOIR_CHART_METRIC_QUERY_KEY = 'idfReservoirChart';

export const idfReservoirChartMetricsQuery = ({
  simulation,
}: {
  simulation: SimulationModel;
}) =>
  queryOptions({
    queryKey: [IDF_RESERVOIR_CHART_METRIC_QUERY_KEY, simulation.id],
    queryFn: async () => {
      const targets = simulation.getIdfChartMetricsTargets();
      const response = await listSimulationMetrics({
        simulationId: simulation.id,
        targets,
        rangeFrom: simulation.timeFrom,
        rangeTo: simulation.timeTo,
      });
      const metrics = response.metrics.map(
        (metric) => new ChartMetricModel(metric),
      );
      return new IdfChartOptionsModel(simulation, metrics);
    },
    staleTime: 60 * 5_000,
  });
